export default "__VITE_ASSET__8ikCpmPm__"